import { getAuth0Client } from './getAuth0Client';
import { isOfcAccess } from './ofcAccess';
import { getOfcAccessSessionToken } from './parseSession';

/**
 * The bearer credential of the OFC REST APIs. Auth0 users send their Auth0
 * access token; an Argo access (PE-2215) sends the Parse session of the
 * service account, which the shared API authorizer accepts since PE-2213.
 */
export const getApiAccessToken = async () => {
  if (isOfcAccess()) {
    return getOfcAccessSessionToken();
  }

  const auth0 = await getAuth0Client();
  return auth0.getTokenSilently();
};
